<script setup>
  import { computed, ref, watchEffect } from 'vue';
  import ViewsTabs from '@/components/Views/ViewsTabs';
  import { useI18n } from '@/i18n/i18n.js';
  import { useRoute, useRouter } from 'vue-router/composables';

  const { tc, t } = useI18n();
  const route = useRoute();
  const router = useRouter();
  
  // Track all filters across tab changes
  const searchFilter = ref('');
  const statusFilter = ref('');
  const typeFilter = ref('');
  const coachesFilter = ref('');
  
  // Update filters when query params change
  watchEffect(() => {
    const searchParam = route.query.search;
    if (typeof searchParam === 'string') {
      searchFilter.value = searchParam;
    }
    
    if (typeof route.query.status === 'string') {
      statusFilter.value = route.query.status;
    }
    if (typeof route.query['campaign-type'] === 'string') {
      typeFilter.value = route.query['campaign-type'];
    }
    if (typeof route.query.coach === 'string') {
      coachesFilter.value = route.query.coach;
    }
  });

  // Build query object with all active filters
  const getQueryParams = () => {
    const query = {};
    
    // Only use 'search' parameter going forward
    if (searchFilter.value) {
      query.search = searchFilter.value;
    }
    
    if (statusFilter.value) {
      query.status = statusFilter.value;
    }
    
    if (typeFilter.value) {
      query['campaign-type'] = typeFilter.value;
    }
    
    if (coachesFilter.value) {
      query.coach = coachesFilter.value;
    }
    
    return query;
  };

  const tabs = computed(() => [
    {
      key: 'campaigns',
      label: tc('campaigns.campaigns', 2),
      to: {
        path: '/campaigns',
        query: getQueryParams()
      },
      count: undefined,
      icon: 'kanban',
    },
    {
      key: 'statistics',
      label: t('generics.statistics'),
      to: { 
        path: '/campaigns/statistics',
        query: getQueryParams()
      },
      count: undefined,
      icon: 'activity',
    },
    // {
    //   key: 'incoming-actions',
    //   label: t('campaigns.incoming-actions'),
    //   to: { path: '/incoming-actions' },
    //   count: null,
    //   icon: 'file-cv', //TODO Change icon
    // },
  ]);
  
  // Method to update the search filter
  const updateSearchFilter = (value) => {
    searchFilter.value = value;
    // Update route with new search param, only using 'search' parameter
    router.replace({ 
      path: route.path,
      query: { 
        ...route.query,
        search: value || undefined,
      }
    });
  };

  // Method to update the coaches filter
  const updateCoachesFilter = (value) => {
    coachesFilter.value = value;
    // Update route with new coaches param
    router.replace({
      path: route.path,
      query: {
        ...route.query,
        coach: value || undefined,
      }
    });
  };
</script>

<template>
  <views-tabs :tabs="tabs">
    <template #content>
      <slot />
    </template>
  </views-tabs>
</template>
